<template>
  <div>
    <nuxt-link v-for="{ title, text } in navigation" :key="title" :to="localePath(text) || ''" class="link">
      {{ title }}
    </nuxt-link>
  </div>
</template>

<script>
export default {
  computed: {
    navigation() {
      return this.$t('header.navigation-list').concat({
        text: 'complains',
        title: this.$t('contacts-page.email-complains-title'),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  font-size: 14px;
  margin-right: 20px;
  color: map-get($colors, gray);

  &:not(.active-url) {
    opacity: 0.7;
  }

  @include not-desktop {
    margin-bottom: 30px;
    display: block;
    font-weight: 600;
  }

  @include desktop {
    margin-top: 3px;
    font-weight: 400;
  }

  &:after {
    display: block;
    width: 100%;
    height: 2px;
    background: map-get($colors, secondary);
    transform: scaleX(0);
    transform-origin: left;
    transition: all 0.3s;
    margin-top: 2px;

    @include desktop {
      content: '';
    }
  }

  &.active-url {
    color: map-get($colors, black);
    font-weight: 500;

    &:after {
      transform: scaleX(1);
      color: map-get($colors, black);
    }
  }

  &:hover {
    text-decoration: none;

    &:after {
      transform: scaleX(1);
    }
  }
}
</style>
